import { render, staticRenderFns } from "./PopButton.vue?vue&type=template&id=36d0f800"
import script from "./PopButton.vue?vue&type=script&lang=js"
export * from "./PopButton.vue?vue&type=script&lang=js"
import style0 from "./PopButton.vue?vue&type=style&index=0&id=36d0f800&prod&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports